import { Background, defaultShimmerSpeed, SkeletonProps, StyledSkeleton } from './Skeleton.styled';

type Props = SkeletonProps & {
  /** animation speed in milliseconds for the shimmer */
  shimmerSpeed?: number;
};

export const Skeleton = ({ shimmerSpeed = defaultShimmerSpeed, ...props }: Props) => (
  <StyledSkeleton data-test="skeleton-wrapper" {...props}>
    <Background data-test="skeleton-bg" speed={shimmerSpeed} />
  </StyledSkeleton>
);
